import Header from "@/components/Header";
import AnnouncementBar from "@/components/AnnouncementBar";
import HeroSection from "@/components/HeroSection";
import MarqueeTicker from "@/components/MarqueeTicker";
import ProblemReframe from "@/components/ProblemReframe";
import MeetTheStates from "@/components/MeetTheStates";
import IngredientPhilosophy from "@/components/IngredientPhilosophy";
import UseCases from "@/components/UseCases";
import BrandManifesto from "@/components/BrandManifesto";

import FAQ from "@/components/FAQ";
import SignUpSection from "@/components/SignUpSection";
import Footer from "@/components/Footer";
import ScrollProgress from "@/components/ScrollProgress";
import MobileCTABar from "@/components/MobileCTABar";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <ScrollProgress />
      <AnnouncementBar />
      <Header />
      <main>
        <HeroSection />
        <MarqueeTicker />
        <ProblemReframe />
        <MeetTheStates />
        
        <IngredientPhilosophy />
        
        <UseCases />
        <BrandManifesto />
        
        <FAQ />
        <SignUpSection />
      </main>
      <Footer />
      <MobileCTABar />
    </div>
  );
};

export default Index;
